import { type MouseEvent, useCallback } from 'react';
import { useThrottledCallback } from 'use-debounce';

import { getInstanceIdFromDocumentDomElement, searchForVariationElement } from 'src/data/document';

import { useReadonlyDocumentScoresActions } from '../store';

const HOVER_CHECK_INTERVAL = 100;

/** For the host's editable: the saved item under the mouse expands its score. */
export const useEditableHoverHandlers = () => {
  const actions = useReadonlyDocumentScoresActions();

  const storeHoveredVariation = useThrottledCallback((target: HTMLElement | null) => {
    const variationElement = searchForVariationElement(target);
    actions.activateVariation(
      variationElement ? (getInstanceIdFromDocumentDomElement(variationElement) ?? null) : null
    );
  }, HOVER_CHECK_INTERVAL);

  const onMouseMove = useCallback(
    (event: MouseEvent<HTMLElement>) => storeHoveredVariation(event.target as HTMLElement),
    [storeHoveredVariation]
  );

  const onMouseLeave = useCallback(() => storeHoveredVariation(null), [storeHoveredVariation]);

  return { onMouseMove, onMouseLeave };
};
